import { render, staticRenderFns } from "./ProductsFilterStatus.vue?vue&type=template&id=1648afcf&"
import script from "./ProductsFilterStatus.vue?vue&type=script&lang=js&"
export * from "./ProductsFilterStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports